import React from 'react';
import { IRequirementModel } from '../../../../../../../service/requirement/entity/IRequirementModel';
import { IRequirementService } from '../../../../../../../service/requirement/entity/IRequirementService';
import { IRowContextMenuUI } from '../../../../../../design/dataTable/parts/rowContextMenu/domain/IRowContextMenuUI';
import { RowContextMenuDomain } from '../../../../../../design/dataTable/parts/rowContextMenu/domain/RowContextMenuDomain';
import { IDataTableDomain } from '../../../../../../design/dataTable/store/IDataTableDomain';
import { IMainLayoutDomainStore } from '../../../../../../layout/main/store/domain/IMainLayoutDomainStore';
import { RequirementEntityContextMenuUI } from './RequirementEntityContextMenuUI';
import { ConfirmModal } from '../../../../../../design/modal/confirm/ConfirmModal';
import { ILocalization, ILocalizationToken } from '../../../../../../../application/language/ILocalization';
import { inject } from '../../../../../../../common/container/inject';

export class RequirementEntityContextMenuDomain extends RowContextMenuDomain<IRequirementModel> {
  constructor({
    entityService,
    dataTableDomain,
    layoutDomain,
    ui,
  }: {
    entityService: IRequirementService;
    dataTableDomain: IDataTableDomain<IRequirementModel, any>;
    layoutDomain: IMainLayoutDomainStore;
    ui?: IRowContextMenuUI<IRequirementModel> | null;
  },
    public i18n: ILocalization = inject<ILocalization>(ILocalizationToken),
  ) {
    super(entityService, dataTableDomain, layoutDomain, i18n, ui);
    this.ui = ui || new RequirementEntityContextMenuUI(this);
  }

  async onEditRowInDrawer(row: any): Promise<void> {
    await super.onEditRowInDrawer(row)
    this.dataTableDomain.drawerDomain.ui.isEditMode.setValue(true)
  }

  async deleteRequirementConfirmation(row: IRequirementModel) {
    let isHaveTemplateRequirement = false;

    const allRequirements = this.dataTableDomain.ui.rows.entities.list
    allRequirements.forEach(requirement => {
      if (requirement.mainId === row.id) {
        isHaveTemplateRequirement = true;
      }
    });

    const currentText = isHaveTemplateRequirement
      ? this.i18n.translate('phrases.deleteRequirementWithTemplate')
      : this.i18n.translate('phrases.deleteRequirementWithoutTemplate');

    const Component = () => {
      return (
        <ConfirmModal
          title={this.i18n.translate('phrases.deleteRequirementTitle', { shortName: row?.shortName || '' })}
          text={currentText}
          onCancel={async () => {
            this.layoutDomain.modalWindow.closeModalWindow();
          }}
          onOk={async () => {
            if (row.id) {
              await this.onDeleteRequirementConfirm(row.id);
            }
          }}
          cancelButtonText='phrases.no'
          confirmButtonText='phrases.delete'
        />
      );
    };

    return Component;
  }

  async onDeleteRow(row: IRequirementModel) {
    const confirmComponent = await this.deleteRequirementConfirmation(row);
    this.layoutDomain.modalWindow.showModalWindow(confirmComponent);
  }

  async onDeleteRequirementConfirm(id: string) {
    await this.deleteById(id);
    await this.dataTableDomain.boot();
    await this.layoutDomain.modalWindow.closeModalWindow();
  }
}
